import { Register, ComponentRender } from './factory';

// 引入样式文件
import '../../assets/dynamic/index.less';

// 组件引入
import './form/dy-input';
import './form/dy-textarea';
import './form/dy-radio';
import './form/dy-checkbox';
import './form/dy-datepicker';
import './form/dy-city';
import './form/dy-pcd';
import './form/dy-school';
import './form/dy-picker';
import './form/dy-international-number';
import './form/dy-file-upload';
import './form/dy-graduate';
import './form/dy-select';
import './form/dy-select-multiple';
import './form/dy-province'

export default {
    Register,
    ComponentRender,
};
